'use client';

import { useRouter } from 'next/navigation';
import { useApp } from '@/forApp/states/appState/appState';
import { useUser } from '@/forApp/states/userState/userState';
import Button from '@/shared/Buttons/Button';
import BaseLink from '@/shared/Links/BaseLink';
import Logo from '@/shared/Logo/Logo';
import { ROUTES } from '@/forApp/utils/routes';
import { contactPhones } from '@/forApp/utils/Data';

import styles from './styles.module.css';

export const MobileFooter = () => {
  const { user } = useUser();
  const { addModal } = useApp();

  const router = useRouter();

  const onOpen = () => {
    if (user) router.push(ROUTES.ADD);
    else addModal({ name: 'AuthModal', type: 'login' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerLogo}>
        <Logo />
      </div>
      <div className={styles.footerWrap}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <h4>Портал</h4>
            <BaseLink text={'Услуги'} href={ROUTES.SERVICES} color={'white'} />
            <BaseLink text={'Помощь'} href={ROUTES.FAQ} color={'white'} />
            <BaseLink
              text={'Контакты'}
              href={ROUTES.CONTACTS}
              color={'white'}
            />
            <BaseLink text={'О нас'} href={ROUTES.ABOUT} color={'white'} />
          </div>
          <div className={styles.footerLinks}>
            <h4>Для клиентов</h4>
            <BaseLink
              text={'Личный кабинет'}
              href={'/profile'}
              color={'white'}
            />
            <div className={styles.footerLink} onClick={onOpen}>
              Разместить объявление
            </div>
            <BaseLink
              text={'Контакты'}
              href={ROUTES.CONTACTS}
              color={'white'}
            />
          </div>
          <div className={styles.footerLinks}>
            <h4>Телефоны</h4>
            {contactPhones.map((phone) => (
              <BaseLink
                href={`tel:${phone.replaceAll('-', '')}`}
                text={phone}
                color="white"
                key={phone}
              />
            ))}
          </div>
        </div>
        <div className={styles.btnWrp}>
          <Button
            color={'white'}
            text={'Напишите нам'}
            onClick={() => {
              addModal({
                name: 'ConsultationModal',
                title: 'Получить консультацию',
              });
            }}
          />
        </div>
      </div>
    </footer>
  );
};
